module.exports = "<app-main id=\"main\"></app-main>\n"